<template>
    <div class="tabbed-site-search-vue">
        <div class="mt-3" v-if="dataLoaded">
            <div v-if="currentTotalPageCount > 0">
                <h3 class="heading-5 mb-3">{{getTextFormatted('hl-search-resultsfortextformat', searchText)}}</h3>
                <div v-for="entry in currentPageData">
                    <div class="mb-3">
                        <div class="heading-4 mb-0 text-capitalize"><a v-bind:href="entry.Link" class="">{{entry.Title}}</a></div>
                        <div v-if="entry.Subtitle">{{entry.Subtitle}}</div>
                        <div>{{entry.Description}}</div>
                        <div class="heading-6 text-lowercase"><a v-bind:href="entry.Link">{{entry.Link}}</a></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h3 class="heading-5" v-if="searchType == 'All'">{{getTextFormatted('hl-search-noresultsallformat', searchText)}}</h3>
                <h3 class="heading-5" v-else>{{getTextFormatted('hl-search-noresultscategoryformat',searchText,searchTypeText)}}</h3>
            </div>
        </div>
        <div v-else>
            <h3 class="heading-5">{{getTextFormatted('hl-search-loadingresultsformat',searchText)}}</h3>
        </div>

        <div v-if="currentTotalPageCount > 0">
            <div class="d-flex justify-content-center align-items-center pagination">
                <a v-if="currentPageIndex > 1" :aria-label="'Go to page ' + (currentPageIndex - 1)" aria-role="navigation" class="" href="#" @click.prevent="pagePrevious()"><slot name="hl-search-previous"></slot></a>
                <span v-else class="bg-icon pagination-prev inactive"></span>

                <span :aria-label="'Current page is ' + currentPageIndex + ' of ' + currentTotalPageCount" class="pagination-text">{{getTextFormatted('hl-search-resultscountformat',currentPageIndex,currentTotalPageCount)}}</span>

                <a v-if="currentPageIndex < currentTotalPageCount" :aria-label="'Go to page ' + (currentPageIndex + 1)" aria-role="navigation" class="" href="#" @click.prevent="pageNext()"><slot name="hl-search-next"></slot></a>
                <span v-else class="bg-icon pagination-next inactive"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:
        {
            searchtext: String,
            searchtype: String,
            searchtypetext: String,
            pagesize: String,
            cultureCode: String
        },
        data() {
            return {
                searchText: this.searchtext,
                searchType: this.searchtype,
                searchTypeText: this.searchtypetext,
                searchPageSize: parseInt(this.pagesize),
                currentPageData: [],
                currentPageIndex: 0,
                currentTotalItemCount: 0,
                currentTotalPageCount: 0,
                dataLoaded: false
            };
        },
        created() {
            this.getTabData(1);
        },
        methods: {
            getText: function (key) {
                return this.$slots[key][0].text.trim();
            },
            getTextFormatted: function (formatKey) {
                var format = this.getText(formatKey);
                var args = Array.prototype.slice.call(arguments, 1);
                return format.replace(/{(\d+)}/g, function (match, number) {
                    return typeof args[number] != 'undefined' ? args[number] : match;
                });
            },
            getTabData: function (pageIndex) {
                this.$axios({
                    url: this.cultureCode.toLowerCase() + "/search",
                    params: { searchtext: this.searchText, searchtype: this.searchType, page: pageIndex },
                    headers: { 'Content-Type': 'application/json' },
                    method: "get"
                })
                    .then((response) => {
                        this.currentPageData = response.data.Items;
                        this.currentPageIndex = response.data.PageIndex;
                        this.currentTotalItemCount = response.data.TotalItemCount;
                        this.currentTotalPageCount = this.calcTotalPages(this.currentTotalItemCount, this.searchPageSize);
                        this.dataLoaded = true;
                    });
            },
            pagePrevious: function () {
                this.getTabData(this.currentPageIndex - 1);
                $('html, body').animate({ scrollTop: 0 }, 'fast');
            },
            pageNext: function () {
                this.getTabData(this.currentPageIndex + 1);
                $('html, body').animate({ scrollTop: 0 }, 'fast');
            },
            calcTotalPages: function (itemCount, pageSize) {
                //we expect that if we have 0 items we want 0 pages
                return Math.ceil(itemCount / pageSize);
            }
        },
        computed: {

        }
    }
</script>

<style lang="scss">
</style>